import React from "react";
import { IRouteItem, Loadable } from "@techzyapp/ui-lib";
import { OFFERS_MAIN_PAGE_PATH } from "utils/constants/paths";

const OffersMainPage = Loadable(React.lazy(() => import("./View")));

export const OffersMainPageRoute: IRouteItem = {
  path: OFFERS_MAIN_PAGE_PATH,
  element: React.createElement(OffersMainPage),
  name: "Offers Main Page",
};
